import {
    CONTACT_REMINDER,
    CUSTOM_REMINDER,
    CUSTOM_REMINDER_VALUES_MAP,
    USER_REMINDER,
} from 'shared/constants/event';

import { t } from '@/services/translations/config';

import { CustomOptionItemType } from './components/SelectWithCustomInput/components/CustomOptionsInputModal/types';

export const USER_REMINDER_STANDARD_ITEMS = [
    { value: USER_REMINDER.NONE, type: CustomOptionItemType.Standard },
    { value: USER_REMINDER.BEFORE2HOUR, type: CustomOptionItemType.Standard },
    { value: USER_REMINDER.BEFORE1DAY, type: CustomOptionItemType.Standard },
    { value: USER_REMINDER.BEFORE3DAYS, type: CustomOptionItemType.Standard },
];

export const CUSTOM_REMINDER_ITEMS = [
    {
        value: CUSTOM_REMINDER.MINUTES_BEFORE,
        type: CustomOptionItemType.Custom,
        inputValue: '10',
    },
    { value: CUSTOM_REMINDER.HOURS_BEFORE, type: CustomOptionItemType.Custom },
    { value: CUSTOM_REMINDER.DAYS_BEFORE, type: CustomOptionItemType.Custom },
    { value: CUSTOM_REMINDER.WEEKS_BEFORE, type: CustomOptionItemType.Custom },
];

export const CONTACTS_REMINDER_STANDARD_ITEMS = [
    { value: CONTACT_REMINDER.BEFORE1DAY, type: CustomOptionItemType.Standard },
    {
        value: CONTACT_REMINDER.BEFORE3DAYS,
        type: CustomOptionItemType.Standard,
    },
    {
        value: CONTACT_REMINDER.BEFORE1WEEK,
        type: CustomOptionItemType.Standard,
    },
];

export const CUSTOM_REMINDER_OPTIONS = CUSTOM_REMINDER_ITEMS.map((item) => ({
    ...item,
    text: t(CUSTOM_REMINDER_VALUES_MAP[item.value]),
}));
